import createHttp from './http';
import OneApi from './OneApi';

export const http = createHttp(import.meta.env.VITE_APP_ONE_API);

// Failed calls reject with the whole response, so that the status stays readable
export const oneApi = new OneApi(http);
